// src/components/Dashboard/mockData.js

/**
 * Mock data for current statistics displayed on the dashboard.
 */
export const mockCurrentStats = { assigned: '0/0', sites: 32 };

/**
 * Mock data for absent shifts.
 */
export const mockAbsentShifts = [
    { id: 'absent1', date: '2025-03-31', time: '4:00 PM - 12:00 AM', site: 'Hyderabad HQ' },
    { id: 'absent2', date: '2025-04-02', time: '4:00 PM - 12:00 AM', site: 'Mumbai Branch' },
];

/**
 * Mock data for live rides, including route coordinates for map display.
 */
export const mockLiveRides = [
    { id: 'ride-1234', status: 'in progress', vehicle: 'Top Power TRK', driver: 'Driver 2', destination: 'Matrix Hospital Mehdipatnam', material: 'Cement', speed: 45, battery: 86, startLat: 17.4475, startLng: 78.3731, endLat: 17.4485, endLng: 78.3741, startSiteName: 'Hyderabad HQ', endSiteName: 'Nearby Site',
        route: [{ lat: 17.4475, lng: 78.3731 }, { lat: 17.4485, lng: 78.3741 }, { lat: 17.4495, lng: 78.3751 }]
    },
    { id: 'ride-5678', status: 'not started', vehicle: 'TEST MODEL', driver: 'Pro Driver - 2', destination: 'Warehouse mill 3', material: 'Gravel', speed: null, battery: null, startLat: 19.0760, startLng: 72.8777, endLat: 19.0780, endLng: 72.8797, startSiteName: 'Mumbai Branch', endSiteName: 'Warehouse Mill',
        route: [{ lat: 19.0760, lng: 72.8777 }, { lat: 19.0770, lng: 72.8787 }, { lat: 19.0780, lng: 72.8797 }]
    },
    { id: 'ride-9012', status: 'completed', vehicle: 'Heavy Duty', driver: 'Alpha Driver', destination: 'Central Depot', material: 'Steel', speed: 60, battery: 90, startLat: 13.0827, startLng: 80.2707, endLat: 13.0850, lng: 80.2730, startSiteName: 'Chennai Office', endSiteName: 'Central Depot',
        route: [{ lat: 13.0827, lng: 80.2707 }, { lat: 13.0835, lng: 80.2715 }, { lat: 13.0850, lng: 80.2730 }]
    },
];

/**
 * Mock data for employees that can be assigned to shifts and zones.
 */
export const mockEmployees = [
    'John Doe - Security Officer',
    'Jane Smith - Patrol Officer',
    'Mike Johnson - Site Supervisor',
    'Sarah Wilson - Security Guard',
    'David Brown - Patrol Officer',
    'Lisa Davis - Security Officer',
    'Tom Miller - Site Supervisor',
    'Emily Johnson - Security Guard',
    'Robert Wilson - Patrol Officer',
    'Amanda Brown - Site Supervisor',
    'Michael Davis - Security Officer',
    'Jessica Miller - Security Guard',
];
